var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" AI Enhanced Email "),
      ]),
      _c("button", {
        staticClass: "delete",
        attrs: { type: "button" },
        on: { click: _vm.close },
      }),
    ]),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c(
          "b-field",
          { attrs: { label: "Subject" } },
          [
            _c("b-input", {
              attrs: { type: "text", placeholder: "Email subject" },
              model: {
                value: _vm.emailData.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.emailData, "subject", $$v)
                },
                expression: "emailData.subject",
              },
            }),
          ],
          1
        ),
        _c(
          "b-field",
          { attrs: { label: "To" } },
          [
            _c("b-input", {
              attrs: { type: "email", placeholder: "Recipient email" },
              model: {
                value: _vm.emailData.to,
                callback: function ($$v) {
                  _vm.$set(_vm.emailData, "to", $$v)
                },
                expression: "emailData.to",
              },
            }),
          ],
          1
        ),
        _c("b-field", { attrs: { label: "Email Body" } }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailData.body,
                expression: "emailData.body",
              },
            ],
            staticClass: "textarea",
            attrs: { placeholder: "Email body text", type: "text" },
            domProps: { value: _vm.emailData.body },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.emailData, "body", $event.target.value)
              },
            },
          }),
        ]),
        _c("b-loading", {
          attrs: { "is-full-page": false },
          model: {
            value: _vm.isGenerating,
            callback: function ($$v) {
              _vm.isGenerating = $$v
            },
            expression: "isGenerating",
          },
        }),
      ],
      1
    ),
    _c(
      "footer",
      { staticClass: "modal-card-foot" },
      [
        _c("b-button", {
          attrs: {
            label: "AI Generate",
            type: "is-info",
            loading: _vm.isGenerating,
          },
          on: { click: _vm.generateEmailBody },
        }),
        _c("b-button", {
          attrs: { label: "Send", type: "is-primary", loading: _vm.isSending },
          on: { click: _vm.sendEmail },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }